export enum PlatformEnum {
  salesPortal = 'fhsp',
  clientPortal = 'fhcp',
  clinicalDirectory = 'fhcd',
  virtualClinic = 'fhvc',
  publicSubscription = 'fhps'
}
